export const dnldEntWallet = (builder) => ({
    dnldEntWallet: builder.mutation({
        query: ({ user_id, user_type_id, search, loggedin_user_id, }) => {
            return {
                url: '/download_get_transaction_list',
                method: 'GET',
                params: { user_id, user_type_id, search, loggedin_user_id, },
                headers: {
                    'Content-Type': 'text/csv',
                  },
                  responseHandler: (response)=>response.blob(),
            };
        },
    }),
});